(function () {
  "use strict";

  /*
   * Script iki kez yüklense bile
   * ana listenerlar çoğalmasın.
   */
  if (
    window.__akayOnlineOrderProductInterestLoaded
  ) {
    return;
  }

  window.__akayOnlineOrderProductInterestLoaded =
    true;

  function createRandomId() {
    try {
      if (
        window.crypto &&
        typeof window.crypto.randomUUID ===
          "function"
      ) {
        return window.crypto
          .randomUUID()
          .replace(/-/g, "");
      }
    } catch (error) {
      // Eski tarayıcılar için yedek yöntem.
    }

    return (
      Date.now().toString(36) +
      Math.random()
        .toString(36)
        .slice(2) +
      Math.random()
        .toString(36)
        .slice(2)
    );
  }

  function initializeOnlineOrderButton(
    button
  ) {
    if (!button) {
      return;
    }

    /*
     * Aynı buton ikinci kez initialize edilmesin.
     */
    if (
      button.getAttribute(
        "data-akay-online-order-initialized"
      ) === "1"
    ) {
      return;
    }

    var inlineMessageId =
      button.getAttribute(
        "data-inline-message-id"
      ) || "";

    var inlineMessage =
      document.getElementById(
        inlineMessageId
      );

    if (!inlineMessage) {
      return;
    }

    button.setAttribute(
      "data-akay-online-order-initialized",
      "1"
    );

    var functionUrl =
      button.getAttribute(
        "data-function-url"
      ) || "";

    var relatedSirketId =
      button.getAttribute(
        "data-related-sirket-id"
      ) || "";

    var productId =
      button.getAttribute(
        "data-product-id"
      ) || "";

    var productName =
      button.getAttribute(
        "data-product-name"
      ) || "";

    var productHandle =
      button.getAttribute(
        "data-product-handle"
      ) || "";

    var locale =
      button.getAttribute(
        "data-locale"
      ) || "tr";

    /*
     * Aynı ürün sayfası açılışında
     * yalnızca bir başarılı metrik gönderilir.
     */
    var metricRequestStarted = false;

    var metricEventId =
      "oop_" +
      String(productId).replace(
        /[^a-zA-Z0-9_-]/g,
        ""
      ) +
      "_" +
      createRandomId();

    function showInlineMessage() {
      var actionStack =
        button.closest(
          ".akay-product-action-stack"
        );

      if (actionStack) {
        var existingAppointmentButton =
          actionStack.querySelector(
            "[data-akay-existing-appointment-button]"
          );

        if (existingAppointmentButton) {
          existingAppointmentButton.hidden =
            true;
        }
      }

      button.hidden = true;
      inlineMessage.hidden = false;
    }

    function recordAddToBasketAttemptMetric() {
      if (metricRequestStarted) {
        return;
      }

      var missingValues = [];

      if (!functionUrl) {
        missingValues.push(
          "functionUrl"
        );
      }

      if (!relatedSirketId) {
        missingValues.push(
          "relatedSirketId"
        );
      }

      if (!productId) {
        missingValues.push(
          "productId"
        );
      }

      if (!productName) {
        missingValues.push(
          "productName"
        );
      }

      if (!productHandle) {
        missingValues.push(
          "productHandle"
        );
      }

      if (
        missingValues.length > 0
      ) {
        return;
      }

      var requestBody = {
        data: {
          relatedSirketId:
            relatedSirketId,

          productId:
            productId,

          productName:
            productName,

          productHandle:
            productHandle,

          pagePath:
            window.location.pathname +
            window.location.search,

          locale:
            locale,

          metricEventId:
            metricEventId,
        },
      };

      metricRequestStarted = true;

      fetch(functionUrl, {
        method: "POST",
        mode: "cors",
        cache: "no-store",

        headers: {
          "Content-Type":
            "application/json",
        },

        credentials: "omit",

        body: JSON.stringify(
          requestBody
        ),
      })
        .then(function (response) {
          return response
            .text()
            .then(function (
              responseText
            ) {
              if (!response.ok) {
                metricRequestStarted =
                  false;

                throw new Error(
                  "HTTP " +
                  response.status +
                  ": " +
                  responseText
                );
              }

              return responseText;
            });
        })
        .catch(function () {
          /*
           * Başarısız olursa yeniden
           * denenebilmesine izin verilir.
           */
          metricRequestStarted = false;
        });
    }

    button.addEventListener(
      "click",
      function () {
        showInlineMessage();
        recordAddToBasketAttemptMetric();
      }
    );
  }

  function initializeAllOnlineOrderButtons(
    scope
  ) {
    var rootScope =
      scope || document;

    var buttons =
      rootScope.querySelectorAll(
        "[data-akay-online-order-interest-button]"
      );

    Array.prototype.forEach.call(
      buttons,
      function (button) {
        initializeOnlineOrderButton(
          button
        );
      }
    );
  }

  function initializePage() {
    initializeAllOnlineOrderButtons(
      document
    );
  }

  if (
    document.readyState ===
    "loading"
  ) {
    document.addEventListener(
      "DOMContentLoaded",
      initializePage
    );
  } else {
    initializePage();
  }

  /*
   * Shopify tema editöründe section
   * yeniden yüklenirse yeni butonu initialize et.
   */
  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initializeAllOnlineOrderButtons(
        event.target
      );
    }
  );
})();